import React, { useState, useEffect, useRef } from "react";
import {
    Accordion,
    Button,
    Card,
    Col,
    Collapse,
    Modal,
    OverlayTrigger,
    Row,
    Spinner,
    Table,
    Tooltip,
} from "react-bootstrap";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import { Link, useNavigate } from "react-router-dom";
// import "./adminDashboard.scss";

// import avatar1 from "../../../images/avatar/1.jpg";
import avatar1 from "../../images/avatar/1.jpg";
import ServiceRequestDetails from "../serviceRequestDetails/serviceRequestDetails";
import CallDetails from "../callDetails/callDetails";
import AddUserByAdmin from "../addUserByAdmin/addUserByAdmin";
import ParticularUserDetailsForAdmin from "../particularUserDetailsForAdmin/particularUserDetailsForAdmin";
import ResponceToaster from "../../jsx/components/responceToaster/responceToaster";
import { registeredUser } from "../../service/api/user/registeredUser";
import { useDispatch, useSelector } from "react-redux";
import AcceptRejectModal from "../../jsx/components/modalAcceptReject/modalAcceptreject";
import deleteUser from "../../service/api/user/deleteUserById";
import PaginationAndSearching from "../../component/paginationAndSearching/paginationAndSearching";
import SkeletonTableRow from "../../component/skeletonTableRow/skeletonTableRow";
import InternationalPhoneFormat from "../../ui/InternationalPhoneFormat";
import { lblEmail, lblPhoneNumber, txtAction, txtCreatedDate, txtDashboard, txtDeleteAccountConfirmation, txtLastLogin, txtName, txtNoRecordsFound, txtRole } from "../../dataBaseFile/label";
import { btnAddUser, btnCheckWaitingUsers, btnFeedback } from "../../dataBaseFile/alert";
import verifyUserApi from "../../service/api/user/verifyUser";
import { FaSearch, FaUserCog } from "react-icons/fa";
import { setCurrentPage, setImpersonateAccessToken, setImpersonateFlag, setImpersonateRefreshToken, setImpersonateRoleId, setImpersonateUserId, setUserDetails } from "../../feature/userData/userData";
import { userById } from "../../service/api/user/userById";
import { LuArrowUpDown } from "react-icons/lu";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import SkeletonDivElement from "../../component/skeletonTableRow/skeletonDivElement"
import { resendCompanyInvitationApi } from "../../service/api/companies/resendCompanyInvitation";
import PrimaryButton from "../../jsx/components/button/primaryButton";
import acceptCompanyJoinRequestApi from "../../service/api/companies/acceptCompanyJoinRequest";
import SelectPeriodFilter from "../../jsx/components/fields/selectPeriodFilter";
import deleteCompanyInvitationApi from "../../service/api/companies/deleteCompanyInvitation";
import cancelCompanyInvitationApi from "../../service/api/companies/cancelCompanyInvitation";
import { apiGetRegisteredCompanies } from "../../service/api/companies/getRegisteredCompanies";
import SelectStateCompanies from "../../jsx/components/fields/selectStateCompanies";
const UserLogs = () => {
    const nevigate = useNavigate();
    const { role, permissionArr, impersonateFlag } = useSelector((state) => state.user);
    const permissionArray = permissionArr[0] || []
    const [basicModal, setBasicModal] = useState(false);
    const [initiColor, setInitiColor] = useState(true);
    const [sortingCol, setSortingCol] = useState(true);

    const [skeltonVal, setSkeltonVal] = useState(false);

    const navigate = useNavigate();
    const dispatch = useDispatch();

    const [page, setPage] = React.useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [totalPage, setTotalPage] = useState(1);
    const [elements, setElements] = useState([]);
    const [openDialog, setOpenDialog] = useState(false);
    const [deletingId, setDeletingId] = useState(false);
    const [sortByValue, setSortByValue] = useState("DESC");
    const [columnName, setColumnName] = useState("");
    const [searchValue, setSearchValue] = useState("");
    const [totalNoRecord, setTotalNoRecord] = useState(100);
    const [flag, setFlag] = useState(false);
    const [handleToaster, setHandleToaster] = useState(false);
    const [toasterType, setToasterType] = useState();
    const [resMessage, setResMessage] = useState("");
    const [firstCheck, setFirstCheck] = useState(false);
    const [customeSkeletonLoading, setCustomeSkeletonLoading] = useState(false);
    const [userVerified, setUserVerified] = useState(0)
    const [impersonateModal, setImpersonateModal] = useState(false)
    const [impersonateId, setImpersonateId] = useState()

    const [filtreBox, setFiltreBox] = useState(false);
    const [filtreValue, SetFiltreValue] = useState(1);

    const [allUsers, setAllUsers] = useState(0);
    const [signedUpUsers, setSignedUpUsers] = useState(0);
    const [loggedInUsers, setLoggedInUsers] = useState(0);

    const [signInSignUpFilter, setSignInSignUpFilter] = useState(1);

    const [isExpandedUserId, setIsExpandedUserId] = useState('');
    const [userFilter, setUserFilter] = useState('2');
    const userTypesArr = [
        { id: "2", name: "All users" },
        { id: "0", name: "Registered users" },
        { id: "1", name: "Invited users" },
    ]

    const [periodRangeFilter, setPeriodRangeFilter] = useState('6');
    const periodRangeArr = [
        { id: "6", name: "All" },
        { id: "1", name: "Last 7 days" },
        { id: "2", name: "Last 1 month" },
        { id: "3", name: "Last 3 months" },
        { id: "4", name: "Last 6 months" },
        { id: "5", name: "Last 1 year" },
    ]

    const [userRoleFilter, setUserRoleFilter] = useState('0');
    const userRoleArr = [
        { id: "0", name: "All" },
        { id: "1", name: "Professional" },
        { id: "2", name: "Customer" },
        { id: "3", name: "Super admin" },
        { id: "4", name: "Company admin" },
    ]

    const [companiesList, setCompaniesList] = useState([])
    const [companyIdSuper, setCompanyIdSuper] = useState('')

    useEffect(() => {
        if (permissionArray.includes("VIEW REGISTERED COMPANIES LIST")) {
            const getComapnies = new FormData();
            getComapnies.append("user_id_ids", localStorage.getItem("user_id"));
            getComapnies.append("pagination_flag", 0);
            // getComapnies.append("page_index", page);
            // getComapnies.append("page_size", pageSize);
            // getComapnies.append("sorting_order", sortByValue);
            // getComapnies.append("sorting_column_name", columnName);
            // getComapnies.append("search_area", searchValue);
            dispatch(
                apiGetRegisteredCompanies(getComapnies, (res) => {
                    // setElements(res.data.data);
                    const defaultCompany = { company_id_ids: '', company_name_chr: 'All' };
                    setCompaniesList([defaultCompany, ...res.data.data])
                }, (err) => { })
            );
        }
    }, [])

    const percentage = 70;

    const tooltipDelete = (
        <Tooltip id="tooltip">
            <strong>Delete</strong>
        </Tooltip>
    );
    const tooltipEdit = (
        <Tooltip id="tooltip">
            <strong>Edit</strong>
        </Tooltip>
    );
    const tooltipVerify = (
        <Tooltip id="tooltip">
            <strong>Verify</strong>
        </Tooltip>
    );

    useEffect(() => {
        dispatch(setCurrentPage("Reports"));
    }, []);


    // With new logic
    const [expandedRow, setExpandedRow] = useState(null);



    // Modal triggers for the service requests details
    const [show, setShow] = useState(false);

    // Modal triggers for the service requests details
    const [showCallDetails, setShowCallDetails] = useState(false);

    const handleCloseCallDetails = () => setShowCallDetails(false);
    const handleShowCallDetails = (e) => {
        e.stopPropagation();
        setShowCallDetails(true);
    };



    // Modal triggers for the Particular user details by admin
    const [showParticularUserDetails, setShowParticularUserDetails] =
        useState(false);

    const handleCloseParticularUserDetails = () => {
        onLoadData()
        setShowParticularUserDetails(false);
    };

    const handleShowParticularUserDetails = (e) => {
        e.stopPropagation();
        setShowParticularUserDetails(true);
    };





    // Dummy call check for toaster

    const getCallHistoryDetails = (res) => {

        // const newElements = [...elements, ...res.data];
        // const uniqueElements = Array.from(
        //   new Set(newElements.map(JSON.stringify))
        // ).map(JSON.parse);


        setElements(res.data);
        setTotalNoRecord(res.total_count);


        if (res.total_count % pageSize === 0) {
            setTotalPage(parseInt(res.total_count / pageSize));
        } else {
            setTotalPage(parseInt(res.total_count / pageSize + 1));
        }

    };

    function onLoadData() {

        setSkeltonVal(true);
        setCustomeSkeletonLoading(true);

        const data = new FormData();
        data.append("user_id_ids", localStorage.getItem("user_id"));
        data.append("pagination_flag", 1);
        data.append("page_index", page);
        data.append("page_size", pageSize);
        data.append("sorting_order", sortByValue);
        data.append("sorting_column_name", columnName);
        data.append("search_area", searchValue);
        data.append("invitation_record_flag", userFilter);
        periodRangeFilter && data.append("period_options", periodRangeFilter);
        data.append("user_list_options", signInSignUpFilter);
        userRoleFilter && data.append("role_id_int", userRoleFilter);
        data.append("company_id_ids", companyIdSuper);
        startDate && data.append("from_date_dtm", startDate);
        endDate && data.append("to_date_dtm", endDate);

        dispatch(
            registeredUser(data, (res) => {
                setSkeltonVal(false);
                setElements(res.data.data);
                getCallHistoryDetails(res.data);
                setAllUsers(res?.data?.all_users_count)
                setSignedUpUsers(res?.data?.signed_up_users_count)
                setLoggedInUsers(res?.data?.logged_in_users_count)
                setCustomeSkeletonLoading(false);
                setTotalNoRecord(res.data.total_count);
                if (res.data.total_count % pageSize === 0) {
                    setTotalPage(parseInt(res.data.total_count / pageSize));
                } else {
                    setTotalPage(parseInt(res.data.total_count / pageSize + 1));
                }

            }, (err) => {
                setCustomeSkeletonLoading(true);
            })
        );

        return;
    }

    const handleColumnName = (name) => {
        setSortingCol(false);
        setColumnName(name);

        if (sortByValue === "ASC") {
            setSortByValue("DESC");
        }
        if (sortByValue === "DESC") {
            setSortByValue("ASC");
        }
    };

    const handleOrderValue = (order) => {
        setSortByValue(order);
    };

    const handleSearch = (e) => {
        setPage(1);
        const ele = []
        setElements(ele);
        if (searchValue.trim().length >= 2) {
            onChangePage(1)
            setColumnName('')
        }
        setSearchValue(e.target.value)
    };

    const handleChangeRowsPerPage = (e) => {
        // console.log(e)
        setSearchValue("");
        setPage(1);
        setPageSize(e.target.value);
    };

    const onChangePage = (e, p) => {
        // setPage(p);
        setPage(e);
    };

    useEffect(() => {
        onLoadData();
    }, [sortByValue, pageSize, page, columnName, filtreValue, userFilter, periodRangeFilter, signInSignUpFilter, userRoleFilter, companyIdSuper]);

    useEffect(() => {
        // if (searchValue.trim().length > 2) {
        //   const ele = [];
        //   setPage(1);
        //   setElements(ele);
        //   setFlag(true);
        //   const timeOutId = setTimeout(onLoadSearch, 1000);
        //   return () => clearTimeout(timeOutId);
        // } else if (searchValue.trim().length === 0 || searchValue.trim() == "") {
        //   if (flag) {
        //     onLoadData();
        //   }
        // }

        if (searchValue.trim().length > 2) {
            setFlag(true);
            const timeOutId = setTimeout(onLoadSearch, 1000);
            return () => clearTimeout(timeOutId);
        } else if (searchValue.trim().length === 0) {
            if (flag) {
                onLoadSearch();
            }
        }
    }, [searchValue]);

    function onLoadSearch() {
        setSkeltonVal(true);
        var data = {
            user_id_ids: localStorage.getItem("user_id"),
            pagination_flag: 1,
            page_index: 1,
            page_size: pageSize,
            sorting_order: sortByValue,
            sorting_column_name: "",
            search_area: searchValue,
            invitation_record_flag: userFilter,
            period_options: periodRangeFilter ? periodRangeFilter : 0,
            user_list_options: signInSignUpFilter,
            role_id_int: userRoleFilter ? userRoleFilter : 0,
            company_id_ids: companyIdSuper,
            from_date_dtm: startDate,
            to_date_dtm: endDate,
        };
        dispatch(
            registeredUser(data, (res) => {
                setSkeltonVal(false);
                getCallHistoryDetails(res.data);
                setAllUsers(res?.data?.all_users_count);
                setSignedUpUsers(res?.data?.signed_up_users_count)
                setLoggedInUsers(res?.data?.logged_in_users_count)
                // setElements(res.data.data);
                // setTotalNoRecord(res.data.total_count);
                // if (res.data.total_count % pageSize === 0) {
                //   setTotalPage(parseInt(res.data.total_count / pageSize));
                // } else {
                //   setTotalPage(parseInt(res.data.total_count / pageSize + 1));
                // }

            })
        );
    }



    function handleSetFiltreValue(v) {
        SetFiltreValue(v);
        const ele = [];
        setPage(1);
        setElements(ele);
        if (v === 1) {
            setSortByValue("DESC");
        } else if (v === 2) {
            setSortByValue("ASC");
        }
    }

    function handleOpenFiltreBox() {
        setFiltreBox(!filtreBox);
    }

    const searchAreaVal = (e) => {
        // setSearchArea(e.target.value)
        // if (searchArea.trim().length >= 2) {
        //     onChangePage(1)
        // }

        setSearchValue(e.target.value)
        if (searchValue.trim().length >= 2) {
            onChangePage(1)
        }
    }

    // Format the unix time in given format
    function formatUnixTimestamp(unixTimestamp) {
        const date = new Date(unixTimestamp * 1000);

        const month = date.toLocaleString('default', { month: 'short' });
        const day = date.getDate();
        let hour = date.getHours();
        const minute = date.getMinutes();

        const hourFormatted = hour % 12 || 12; // Convert 24-hour time to 12-hour format
        const amPm = hour < 12 ? 'am' : 'pm';
        const minuteFormatted = minute < 10 ? `0${minute}` : minute;

        return `${month} ${day}, ${hourFormatted}:${minuteFormatted} ${amPm}`;
    }


    const handleUserFilter = (e) => {
        setUserFilter(e.target.value);
    }

    const handlePeriodRangeFilter = (e) => {
        setPeriodRangeFilter(e.target.value);
    }

    const handleUserRoleFilter = (e) => {
        setUserRoleFilter(e.target.value);
    }


    function handleCompaniesSelectValue(e) {
        setCompanyIdSuper(e.target.value)
    }

    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);

    // Using useRef for both date pickers
    const startDateRef = useRef(null);
    const endDateRef = useRef(null);

    const handleStartDateClick = () => {
        startDateRef.current.showPicker();
    };

    const handleEndDateClick = () => {
        endDateRef.current.showPicker();
    };

    const handleStartDateChange = () => {
        // setStartDate(startDateRef.current.value);
        const selectedDate = startDateRef.current.value;
        const unixStartDate = Math.floor(new Date(selectedDate).getTime() / 1000);
        setStartDate(unixStartDate);
    };

    const handleEndDateChange = () => {
        // setEndDate(endDateRef.current.value);
        const selectedDate = endDateRef.current.value;
        const unixEndDate = Math.floor(new Date(selectedDate).getTime() / 1000);
        setEndDate(unixEndDate);
    };

    // console.log(startDate, "startDate", endDate, "endDate");

    const [isDatesClear, setIsDatesClear] = useState(false);
    const clearDatesFilter = () => {
        setStartDate(null);
        setEndDate(null);
        startDateRef.current.value = ''; // Clear the actual input field value
        endDateRef.current.value = ''; // Clear the actual input field value
        setIsDatesClear(prev => !prev)
        // onLoadData();
    }

    const isFirstRender = useRef(true);
    useEffect(() => {
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return;
        }
        onLoadData();
    }, [isDatesClear]);

    const [isMounted, setIsMounted] = useState(true);

    const clearAllFilters = () => {
        clearDatesFilter();
        setPeriodRangeFilter('6');
        setUserRoleFilter('0');
        setCompanyIdSuper('');
        setSearchValue('');
        setSignInSignUpFilter(1);

        setIsMounted(false);
        setTimeout(() => setIsMounted(true), 0);
    }

    const [downloadLogsLoading, setDownloadLogsLoading] = useState(false);
    const downloadLogsFn = () => {

        setDownloadLogsLoading(true);

        const data = new FormData();
        data.append("user_id_ids", localStorage.getItem("user_id"));
        data.append("pagination_flag", 1);
        data.append("page_index", page);
        data.append("page_size", pageSize);
        data.append("sorting_order", sortByValue);
        data.append("sorting_column_name", columnName);
        data.append("search_area", searchValue);
        data.append("invitation_record_flag", userFilter);
        periodRangeFilter && data.append("period_options", periodRangeFilter);
        data.append("user_list_options", signInSignUpFilter);
        userRoleFilter && data.append("role_id_int", userRoleFilter);
        data.append("company_id_ids", companyIdSuper);
        startDate && data.append("from_date_dtm", startDate);
        endDate && data.append("to_date_dtm", endDate);
        data.append("download_report_flag", 1);

        dispatch(
            registeredUser(data, (res) => {
                setDownloadLogsLoading(false);
                // console.log(res.data);

                const blob = new Blob([res.data], { type: 'text/csv;charset=utf-8;' });

                const url = URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `user_report_${new Date().toLocaleString().replace(/[^\w\s]/gi, '_')}.csv`); // Filename for download
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link); // Clean up
            }, (err) => {
                setDownloadLogsLoading(false);
            })
        );

        return;
    }



    return (
        <>
            {/* New Admin dashboard */}
            <div className="row mx-3 mb-5" style={{}}>
                <div className="col-12 px-0">



                    {/* <input type="date" id="start" name="trip-start" /> */}

                    <div className="row mx-0 p-3">
                        <div className="col-lg-6 px-0 ps-2 d-flex align-item-center justify-content-start">
                            <span className="fs-4 fw-bold text-black">{"Users report"}</span>
                        </div>

                        <div className="col-lg-6 px-0 pe-2 d-flex align-item-center justify-content-end">

                        </div>
                    </div>


                    {(permissionArray.includes("VIEW REGISTERED COMPANIES LIST")) &&
                        <div className="row mx-0 mb-3">
                            <div className="col-12 px-0 d-flex align-item-center justify-content-end">

                                <div
                                    className="d-flex flex-column shadow rounded-2 cursor-pointer bg-white me-3"
                                    style={{ width: '140px' }}
                                    onClick={(e) => { handleStartDateClick() }}
                                >
                                    <div className="fs-7 d-flex justify-content-center align-items-center bg-primary rounded-top p-2 text-white font-w600">
                                        <span className="me-2"><i className="bi bi-calendar-range"></i></span>
                                        <span>{`Select start date`}</span>
                                    </div>
                                    <div className="d-flex justify-content-center align-items-center p-2">
                                        <span className="font-w600 text-black">{
                                            startDate ?
                                                new Date(startDate * 1000).toLocaleDateString('en-US', {
                                                    month: 'short',
                                                    day: '2-digit',
                                                    year: 'numeric',
                                                }) : '-'}</span>
                                    </div>

                                    {/* Hidden Input for Start Date */}
                                    <input
                                        type="date"
                                        ref={startDateRef}
                                        onChange={handleStartDateChange}
                                        max={new Date().toISOString().split('T')[0]}
                                        // style={{ display: 'none' }}
                                        style={{ visibility: 'hidden', width: '0', height: '0' }}
                                    />
                                </div>

                                <div
                                    className="d-flex flex-column shadow rounded-2 cursor-pointer bg-white"
                                    style={{ width: '140px' }}
                                    onClick={(e) => { handleEndDateClick() }}
                                >
                                    <div className="fs-7 d-flex justify-content-center align-items-center bg-primary rounded-top p-2 text-white font-w600">
                                        <span className="me-2"><i className="bi bi-calendar-range"></i></span>
                                        <span>{`Select end date`}</span>
                                    </div>
                                    <div className="d-flex justify-content-center align-items-center p-2">
                                        <span className="font-w600 text-black">{
                                            endDate ?
                                                new Date(endDate * 1000).toLocaleDateString('en-US', {
                                                    month: 'short',
                                                    day: '2-digit',
                                                    year: 'numeric',
                                                }) : '-'}</span>
                                    </div>

                                    {/* Hidden Input for End Date */}
                                    <input
                                        type="date"
                                        ref={endDateRef}
                                        onChange={handleEndDateChange}
                                        max={new Date().toISOString().split('T')[0]}
                                        // style={{ display: 'none' }}
                                        style={{ visibility: 'hidden', width: '0', height: '0' }}
                                    />

                                </div>

                                {startDate && endDate &&
                                    <div className="d-flex align-items-center justify-content-center mx-2">
                                        <div className="tooltipCustom">
                                            <span className="tooltiptextCustom w-100" style={{ minWidth: 'max-content' }}>{"Apply date"}</span>
                                            <span
                                                className="font-w600 text-black overlay-action-btn cursor-pointer rounded-circle d-flex align-items-center justify-content-center"
                                                onClick={(e) => onLoadData()}
                                                style={{ height: '40px', width: '40px', }}
                                            >
                                                <i className="bi bi-check2-circle text-success" style={{ color: 'green', fontSize: '25px' }} />
                                            </span>
                                        </div>
                                    </div>
                                }

                                {startDate && endDate &&
                                    <div className="d-flex align-items-center justify-content-center mx-2">
                                        <div className="tooltipCustom">
                                            <span className="tooltiptextCustom w-100" style={{ minWidth: 'max-content' }}>{"Clear date filter"}</span>
                                            <span
                                                className="font-w600 text-black overlay-action-btn cursor-pointer rounded-circle d-flex align-items-center justify-content-center"
                                                onClick={(e) => clearDatesFilter()}
                                                style={{ height: '40px', width: '40px', }}
                                            >
                                                <i className="bi bi-x-circle text-danger" style={{ fontSize: '25px' }} />
                                            </span>
                                        </div>
                                    </div>
                                }
                            </div>
                        </div>
                    }

                    {(permissionArray.includes("VIEW REGISTERED COMPANIES LIST")) &&
                        <div className="row">
                            {/* <div className="col-12 col-md-3 pe-md-2 mb-2">
                                <div
                                    className={`h-100 d-flex rounded p-2 cursor-pointer border-hovered ${signInSignUpFilter === 0 ? 'shadow-sm' : ''}`}
                                    style={{ border: signInSignUpFilter === 0 ? '2px solid orange' : '2px solid #c8c4c487' }}
                                    onClick={() => setSignInSignUpFilter(0)}
                                >
                                    <div className="d-flex align-items-center">
                                        <div className="me-2" style={{ fontSize: '40px' }}>
                                            <i className="bi bi-person-fill"></i>
                                        </div>
                                        <div className="d-flex flex-column">
                                            <div className="mb-1"><span className="fs-5 font-w600 text-black">{"All users"}</span></div>
                                            <div><span className="fs-3 font-w600 text-black">{`${allUsers}`}</span></div>
                                        </div>
                                    </div>
                                </div>
                            </div> */}

                            <div className="col-12 col-md-3 pe-md-2 mb-2">
                                <div
                                    className={`h-100 d-flex rounded p-2 cursor-pointer border-hovered ${signInSignUpFilter === 1 ? 'shadow-sm' : ''}`}
                                    style={{ border: signInSignUpFilter === 1 ? '2px solid orange' : '2px solid #c8c4c487' }}
                                    onClick={() => setSignInSignUpFilter(1)}
                                >
                                    <div className="d-flex align-items-center">
                                        <div className="me-2" style={{ fontSize: '40px' }}>
                                            <i className="bi bi-person-fill"></i>
                                        </div>
                                        <div className="d-flex flex-column">
                                            <div className="mb-1"><span className="fs-5 font-w600 text-black">{"Registered users"}</span></div>
                                            <div><span className="fs-3 font-w600 text-black">{`${signedUpUsers}`}</span></div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="col-12 col-md-3 pe-md-2 mb-2">
                                <div
                                    className={`h-100 d-flex rounded p-2 cursor-pointer border-hovered ${signInSignUpFilter === 2 ? 'shadow-sm' : ''}`}
                                    style={{ border: signInSignUpFilter === 2 ? '2px solid orange' : '2px solid #c8c4c487' }}
                                    onClick={() => setSignInSignUpFilter(2)}
                                >
                                    <div className="d-flex align-items-center">
                                        <div className="me-2" style={{ fontSize: '40px' }}>
                                            <i className="bi bi-person-fill"></i>
                                        </div>
                                        <div className="d-flex flex-column">
                                            <div className="mb-1"><span className="fs-5 font-w600 text-black">{"Logged in"}</span></div>
                                            <div><span className="fs-3 font-w600 text-black">{`${loggedInUsers}`}</span></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }




                    <div className="mt-4 d-flex justify-content-start row">
                        {(permissionArray.includes("VIEW REGISTERED COMPANIES LIST")) &&
                            <div className=" col-sm-3 pe-sm-2" style={{ width: '' }}>
                                {isMounted && <SelectStateCompanies
                                    labelName={"Company"}
                                    options={companiesList}
                                    onChange={handleCompaniesSelectValue}
                                    defaultValue={companyIdSuper}
                                />}
                            </div>
                        }

                        {(permissionArray.includes("VIEW REGISTERED COMPANIES LIST")) &&
                            <div className=" col-sm-3 pe-sm-2" style={{ width: '' }}>
                                {isMounted && <SelectPeriodFilter
                                    labelName={`Filter by role`}
                                    onChange={(e) => handleUserRoleFilter(e)}
                                    defaultValue={userRoleFilter}
                                    options={userRoleArr}
                                    errorOccured={false}
                                    errorMessage={""}
                                />}
                            </div>
                        }

                        {(permissionArray.includes("VIEW REGISTERED COMPANIES LIST")) &&
                            <div className="col-sm-3 pe-sm-2" style={{ width: '' }}>
                                {isMounted && <SelectPeriodFilter
                                    labelName={`Filter by range`}
                                    onChange={(e) => handlePeriodRangeFilter(e)}
                                    defaultValue={periodRangeFilter}
                                    options={periodRangeArr}
                                    errorOccured={false}
                                    errorMessage={""}
                                />}
                            </div>
                        }

                        {(permissionArray.includes("VIEW REGISTERED COMPANIES LIST")) &&
                            <div className="col-xl-3 col-12  pe-sm-2 d-flex" style={{ width: '' }}>
                                <span
                                    className="px-3 py-1 cursor-pointer text-primary  font-w600 rounded overlay-action-btn bg-light d-flex align-items-center justify-content-center me-2"
                                    style={{ height: '40px' }}
                                    onClick={() => clearAllFilters()}
                                >
                                    {`Clear all `}
                                </span>

                                <span
                                    className="px-3 py-1 cursor-pointer text-primary  font-w600 rounded overlay-action-btn bg-light d-flex align-items-center justify-content-center"
                                    style={{
                                        height: '40px',
                                        pointerEvents: downloadLogsLoading || elements?.length == 0 ? 'none' : 'auto',
                                        opacity: downloadLogsLoading || elements?.length == 0 ? '0.5' : '1',
                                    }}
                                    onClick={() => { downloadLogsFn() }}
                                >
                                    <span className="me-2" style={{ marginBottom: '2px' }}>
                                        {downloadLogsLoading ?
                                            <Spinner size="sm" /> :
                                            <i class="bi bi-box-arrow-in-down"></i>
                                        }
                                    </span>

                                    {`Download report`}
                                </span>
                            </div>
                        }

                        {(permissionArray.includes("VIEW COMPANY USERS")) &&
                            <div className="col-sm-3" style={{ width: '' }}>
                                <SelectPeriodFilter
                                    labelName={`Filter by users`}
                                    onChange={(e) => handleUserFilter(e)}
                                    defaultValue={userFilter}
                                    options={userTypesArr}
                                    errorOccured={false}
                                    errorMessage={""}
                                />
                            </div>
                        }
                    </div>


                    <div className='my-3'>
                        <PaginationAndSearching
                            handleSearch={searchAreaVal}
                            // searchValue={searchArea}
                            searchValue={searchValue}
                            defaultValue={pageSize}
                            handleChangeRowsPerPage={handleChangeRowsPerPage}
                            totalCount={totalPage}
                            onChange={onChangePage}
                        />
                    </div>

                    <Table responsive>

                        <thead>
                            <tr className='text-black bg-light'>

                                <th
                                    className='cursor-pointer'
                                    style={{ fontWeight: '700' }}
                                    onClick={() => { handleColumnName("first_name_chr") }}
                                >
                                    {`Name`}
                                    <span className="ml-1">
                                        {columnName === 'first_name_chr' ? (
                                            <>
                                                {sortByValue === "DESC" && <i className="fa fa-arrow-down ms-2 fs-14" style={{ opacity: '0.7' }} onClick={() => { handleOrderValue("ASC") }} />}

                                                {sortByValue === "ASC" && <i className="fa fa-arrow-up ms-2 fs-14" style={{ opacity: '0.7' }} onClick={() => { handleOrderValue("DESC") }} />}

                                            </>
                                        )
                                            :
                                            (<i className="fa fa-sort ms-2 fs-14" style={{ opacity: '0.3' }} />)
                                        }
                                    </span>
                                </th>
                                <th
                                    // className='cursor-pointer'
                                    style={{ fontWeight: '700' }}
                                // onClick={() => { handleColumnName("role_id_ids") }}
                                >
                                    {`Role`}
                                    {/* <span className="ml-1">
                    {columnName === 'role_id_ids' ? (
                      <>
                        {sortByValue === "DESC" && <i className="fa fa-arrow-down ms-2 fs-14" style={{ opacity: '0.7' }} onClick={() => { handleOrderValue("ASC") }} />}

                        {sortByValue === "ASC" && <i className="fa fa-arrow-up ms-2 fs-14" style={{ opacity: '0.7' }} onClick={() => { handleOrderValue("DESC") }} />}

                      </>
                    )
                      :
                      (<i className="fa fa-sort ms-2 fs-14" style={{ opacity: '0.3' }} />)
                    }
                  </span> */}
                                </th>

                                <th
                                    className='cursor-pointer'
                                    style={{ fontWeight: '700' }}
                                    onClick={() => { handleColumnName("email_chr") }}
                                >
                                    {`Email`}
                                    <span className="ml-1">
                                        {columnName === 'email_chr' ? (
                                            <>
                                                {sortByValue === "DESC" && <i className="fa fa-arrow-down ms-2 fs-14" style={{ opacity: '0.7' }} onClick={() => { handleOrderValue("ASC") }} />}

                                                {sortByValue === "ASC" && <i className="fa fa-arrow-up ms-2 fs-14" style={{ opacity: '0.7' }} onClick={() => { handleOrderValue("DESC") }} />}

                                            </>
                                        )
                                            :
                                            (<i className="fa fa-sort ms-2 fs-14" style={{ opacity: '0.3' }} />)
                                        }
                                    </span>
                                </th>
                                <th
                                    className='cursor-pointer'
                                    style={{ fontWeight: '700' }}
                                    onClick={() => { handleColumnName("phone_number_int") }}
                                >
                                    {`Phone`}
                                    <span className="ml-1">
                                        {columnName === 'phone_number_int' ? (
                                            <>
                                                {sortByValue === "DESC" && <i className="fa fa-arrow-down ms-2 fs-14" style={{ opacity: '0.7' }} onClick={() => { handleOrderValue("ASC") }} />}

                                                {sortByValue === "ASC" && <i className="fa fa-arrow-up ms-2 fs-14" style={{ opacity: '0.7' }} onClick={() => { handleOrderValue("DESC") }} />}

                                            </>
                                        )
                                            :
                                            (<i className="fa fa-sort ms-2 fs-14" style={{ opacity: '0.3' }} />)
                                        }
                                    </span>
                                </th>


                                <th
                                    className='cursor-pointer'
                                    style={{ fontWeight: '700' }}
                                    onClick={() => { handleColumnName("created_date_dtm") }}
                                >
                                    {`Created on`}
                                    <span className="ml-1">
                                        {columnName === 'created_date_dtm' ? (
                                            <>
                                                {sortByValue === "DESC" && <i className="fa fa-arrow-down ms-2 fs-14" style={{ opacity: '0.7' }} onClick={() => { handleOrderValue("ASC") }} />}

                                                {sortByValue === "ASC" && <i className="fa fa-arrow-up ms-2 fs-14" style={{ opacity: '0.7' }} onClick={() => { handleOrderValue("DESC") }} />}

                                            </>
                                        )
                                            :
                                            (<i className="fa fa-sort ms-2 fs-14" style={{ opacity: '0.3' }} />)
                                        }
                                    </span>
                                </th>
                                <th
                                    className='cursor-pointer'
                                    style={{ fontWeight: '700' }}
                                    onClick={() => { handleColumnName("last_log_in_dtm") }}
                                >
                                    {`Last login`}
                                    <span className="ml-1">
                                        {columnName === 'last_log_in_dtm' ? (
                                            <>
                                                {sortByValue === "DESC" && <i className="fa fa-arrow-down ms-2 fs-14" style={{ opacity: '0.7' }} onClick={() => { handleOrderValue("ASC") }} />}

                                                {sortByValue === "ASC" && <i className="fa fa-arrow-up ms-2 fs-14" style={{ opacity: '0.7' }} onClick={() => { handleOrderValue("DESC") }} />}

                                            </>
                                        )
                                            :
                                            (<i className="fa fa-sort ms-2 fs-14" style={{ opacity: '0.3' }} />)
                                        }
                                    </span>
                                </th>

                                <th></th>
                            </tr>
                        </thead>

                        <tbody>
                            {customeSkeletonLoading ?
                                <SkeletonTableRow cols={7} /> :
                                <>
                                    {elements?.length > 0 ?
                                        <>
                                            {elements?.map((element, index) => {
                                                return (
                                                    <>
                                                        <tr
                                                            className={`notification-rows font-w700 ${isExpandedUserId === element.user_id_ids ? "bg-primary text-white " : ""}`}
                                                            key={index}
                                                            style={{
                                                                cursor: element?.invitation_id_ids ? "default" : "pointer"
                                                            }}
                                                            onClick={() => {
                                                                // onRowClick(element)
                                                                if (!element?.invitation_id_ids) {
                                                                    if (element?.user_id_ids === isExpandedUserId) {
                                                                        setIsExpandedUserId('')
                                                                    } else {
                                                                        setIsExpandedUserId(element.user_id_ids)
                                                                    }
                                                                }
                                                            }}
                                                        >
                                                            <td>
                                                                <div className="d-flex align-items-center">
                                                                    <img
                                                                        // src={profilePicture}
                                                                        src={element?.preferred_profile_picture_url}
                                                                        className={`rounded-lg me-2 ${element?.user_id_ids === isExpandedUserId ? "border" : ""} rounded-3`}
                                                                        width="24"
                                                                        height="24"
                                                                        alt=""
                                                                        style={{ objectFit: "contain" }}
                                                                    />{" "}
                                                                    <span className="w-space-no">{`${element.first_name_chr ? element.first_name_chr : "-"} ${element.last_name_chr ? element.last_name_chr : ""}`}</span>
                                                                </div>
                                                            </td>

                                                            <td>
                                                                <span
                                                                    className="fs-7 px-3 py-1 text-white font-w700 rounded-pill"
                                                                    style={{
                                                                        background: "rgba(79, 93, 116, 1)",
                                                                    }}>
                                                                    {`${element?.role_display_name_chr}`}
                                                                </span>
                                                            </td>


                                                            <td>
                                                                <span className="w-space-no">{element.email_chr ? element.email_chr : "-"}</span>
                                                            </td>

                                                            <td>
                                                                <span>{element.phone_number_int == null ? ('-') : <InternationalPhoneFormat countryCode={element.country_phone_code_chr} phoneNumber={`${element.phone_number_int}`} />}</span>
                                                            </td>

                                                            <td>
                                                                {/* <span className="">{`${element?.created_date_dtm ? formatUnixTimestamp(element?.created_date_dtm) : '-'}`}</span> */}

                                                                <span className="">{`${element?.created_date_dtm ?
                                                                    new Intl.DateTimeFormat("en-US", {
                                                                        year: "numeric",
                                                                        month: "short",
                                                                        day: "numeric",
                                                                        hour: 'numeric',
                                                                        minute: 'numeric',
                                                                        hour12: true
                                                                    }).format(
                                                                        element?.created_date_dtm * 1000
                                                                    ) : '-'}`}</span>
                                                            </td>

                                                            <td>
                                                                {/* <span className="">{`${element?.last_log_in_dtm ? formatUnixTimestamp(element?.last_log_in_dtm) : '-'}`}</span> */}

                                                                <span className="">{`${element?.last_log_in_dtm ?
                                                                    new Intl.DateTimeFormat("en-US", {
                                                                        year: "numeric",
                                                                        month: "short",
                                                                        day: "numeric",
                                                                        hour: 'numeric',
                                                                        minute: 'numeric',
                                                                        hour12: true
                                                                    }).format(
                                                                        element?.last_log_in_dtm * 1000
                                                                    ) : '-'}`}</span>
                                                            </td>

                                                            <td>
                                                                {/* <OverlayTrigger placement="top" overlay={tooltip}> */}
                                                                {!element?.invitation_id_ids &&
                                                                    <div
                                                                        onClick={(e) => {
                                                                            e.stopPropagation();
                                                                            if (element?.user_id_ids === isExpandedUserId) {
                                                                                setIsExpandedUserId('')
                                                                            } else {
                                                                                setIsExpandedUserId(element.user_id_ids)
                                                                            }
                                                                        }}
                                                                        className="d-flex align-items-center justify-content-center bg-light rounded-3 overlay-action-btn text-black"
                                                                        style={{ fontSize: '15px', height: '30px', width: '35px' }}>
                                                                        {element?.user_id_ids === isExpandedUserId ? <i class="bi bi-chevron-down"></i> : <i class="bi bi-chevron-right"></i>}
                                                                    </div>
                                                                }
                                                                {/* </OverlayTrigger> */}
                                                            </td>
                                                        </tr >

                                                        <tr>
                                                            <td colSpan="8" className={`bg-light ${(element?.user_id_ids !== isExpandedUserId) ? 'p-0' : ''}`}>
                                                                <Collapse
                                                                    in={element?.user_id_ids === isExpandedUserId}
                                                                >
                                                                    <div className='row mx-0'>
                                                                        <div className='col-12 px-0'>

                                                                            <div className='row mx-0 py-1 fs-6'>
                                                                                <div className='col-4 px-0 '>
                                                                                    <span className="text-black font-w600">{`Full name`}</span>
                                                                                </div>
                                                                                <div className='col-8 px-0 '>
                                                                                    <span className="">{`${element.first_name_chr ? element.first_name_chr : "-"} ${element.last_name_chr ? element.last_name_chr : ""}`}</span>
                                                                                </div>
                                                                            </div>

                                                                            <div className='row mx-0 py-1 fs-6'>
                                                                                <div className='col-4 px-0 '>
                                                                                    <span className="text-black font-w600">{`Email`}</span>
                                                                                </div>
                                                                                <div className='col-8 px-0 '>
                                                                                    <span className="" >{element.email_chr ? element.email_chr : "-"}</span>
                                                                                </div>
                                                                            </div>

                                                                            <div className='row mx-0 py-1 fs-6'>
                                                                                <div className='col-4 px-0 '>
                                                                                    <span className="text-black font-w600">{`Phone`}</span>
                                                                                </div>
                                                                                <div className='col-8 px-0 '>
                                                                                    <span className="" >{element.phone_number_int == null ? ('-') : <InternationalPhoneFormat countryCode={element.country_phone_code_chr} phoneNumber={`${element.phone_number_int}`} />}</span>
                                                                                </div>
                                                                            </div>

                                                                            <div className='row mx-0 py-1 fs-6'>
                                                                                <div className='col-4 px-0 '>
                                                                                    <span className="text-black font-w600">{`Created on`}</span>
                                                                                </div>
                                                                                <div className='col-8 px-0 '>
                                                                                    {/* <span className="">{`${element?.created_date_dtm ? formatUnixTimestamp(element?.created_date_dtm) : '-'}`}</span> */}

                                                                                    <span className="">{`${element?.created_date_dtm ?
                                                                                        new Intl.DateTimeFormat("en-US", {
                                                                                            year: "numeric",
                                                                                            month: "short",
                                                                                            day: "numeric",
                                                                                            hour: 'numeric',
                                                                                            minute: 'numeric',
                                                                                            hour12: true
                                                                                        }).format(
                                                                                            element?.created_date_dtm * 1000
                                                                                        ) : '-'}`}</span>
                                                                                </div>
                                                                            </div>

                                                                            <div className='row mx-0 py-1 fs-6'>
                                                                                <div className='col-4 px-0 '>
                                                                                    <span className="text-black font-w600">{`Last login`}</span>
                                                                                </div>
                                                                                <div className='col-8 px-0 '>
                                                                                    {/* <span className="">{`${element?.last_log_in_dtm ? formatUnixTimestamp(element?.last_log_in_dtm) : '-'}`}</span> */}

                                                                                    <span className="">{`${element?.last_log_in_dtm ?
                                                                                        new Intl.DateTimeFormat("en-US", {
                                                                                            year: "numeric",
                                                                                            month: "short",
                                                                                            day: "numeric",
                                                                                            hour: 'numeric',
                                                                                            minute: 'numeric',
                                                                                            hour12: true
                                                                                        }).format(
                                                                                            element?.last_log_in_dtm * 1000
                                                                                        ) : '-'}`}</span>
                                                                                </div>
                                                                            </div>



                                                                            <div className='row mx-0 py-1 fs-6'>
                                                                                <div className='col-4 px-0 '>
                                                                                    <span className="text-black font-w600">{`Status`}</span>
                                                                                </div>
                                                                                <div className='col-8 px-0 '>
                                                                                    <span className=" font-w600" style={{ color: element?.is_verified_ysn ? "rgba(45, 204, 99, 1)" : "rgba(255, 0, 0, 1)" }}>{element?.is_verified_ysn ? `Verified` : `Unverified`}</span>
                                                                                </div>
                                                                            </div>

                                                                        </div>
                                                                    </div>
                                                                </Collapse>
                                                            </td>
                                                        </tr>
                                                    </>
                                                )
                                            })}</> :
                                        <tr>
                                            <td colSpan="7">No Records Found</td>
                                        </tr>
                                    }
                                </>
                            }
                        </tbody>
                    </Table>


                </div>
            </div >

            {
                handleToaster && (
                    <ResponceToaster toasterType={toasterType} message={resMessage} />
                )
            }
        </>
    );
};

export default UserLogs;
